import { create } from 'zustand';

const MAX_ENTRIES = 200;

export interface NetworkEntry {
  id: string;
  method: string;
  url: string;
  status?: number;
  duration?: number;
  requestHeaders?: Record<string, string>;
  requestBody?: any;
  responseBody?: any;
  timestamp: number;
  error?: string;
}

export interface LogEntry {
  id: string;
  level: string;
  logger: string;
  message: string;
  timestamp: number;
}

interface DevConsoleState {
  visible: boolean;
  activeTab: 'network' | 'logs';
  networkEntries: NetworkEntry[];
  logEntries: LogEntry[];
  wsConnected: boolean;
  toggle: () => void;
  setVisible: (v: boolean) => void;
  setActiveTab: (tab: 'network' | 'logs') => void;
  addNetworkEntry: (entry: NetworkEntry) => void;
  updateNetworkEntry: (id: string, update: Partial<NetworkEntry>) => void;
  addLogEntry: (entry: LogEntry) => void;
  clearNetwork: () => void;
  clearLogs: () => void;
  setWsConnected: (connected: boolean) => void;
}

let entryId = 0;
export const genId = () => `${Date.now()}-${++entryId}`;

export const useDevConsoleStore = create<DevConsoleState>((set) => ({
  visible: false,
  activeTab: 'network',
  networkEntries: [],
  logEntries: [],
  wsConnected: false,
  toggle: () => set((s) => ({ visible: !s.visible })),
  setVisible: (v) => set({ visible: v }),
  setActiveTab: (tab) => set({ activeTab: tab }),
  addNetworkEntry: (entry) =>
    set((s) => ({
      networkEntries: [...s.networkEntries, entry].slice(-MAX_ENTRIES),
    })),
  updateNetworkEntry: (id, update) =>
    set((s) => ({
      networkEntries: s.networkEntries.map((e) =>
        e.id === id ? { ...e, ...update } : e
      ),
    })),
  addLogEntry: (entry) =>
    set((s) => ({
      logEntries: [...s.logEntries, entry].slice(-MAX_ENTRIES),
    })),
  clearNetwork: () => set({ networkEntries: [] }),
  clearLogs: () => set({ logEntries: [] }),
  setWsConnected: (connected) => set({ wsConnected: connected }),
}));
